const itsNames = (row) => row.split(/\s+/).at(0);

export const parsePolicyNames = (response) => {
  const lines = response.trim("\n").split("\n");
  const [_head, ...rows] = lines;
  return rows.map(itsNames);
};
